import { toast } from "react-toastify";
import apiLink from "../api/apiLink";
import {
  createIspOwnerOLTSuccess,
  deleteIspOwnerOLTSuccess,
  getCustomerONUSuccess,
  getIspOwnerOLTSuccess,
  getOltEnableVendorsSuccess,
  getOLTUsersSuccess,
  updateIspOwnerOLTSuccess,
  updateOLTUsersSuccess,
  deleteOLTCustomerSuccess,
} from "./olt.Slice";
import {
  deleteNetworkPointSuccess,
  getNetworkDiagramSuccess,
  getNetworkPointSuccess,
  postNetworkPointSuccess,
  updateNetworkDeviceOutputSuccess,
} from "./network.slice";

const netFeeLang = localStorage.getItem("oneBilling:lang");

const langMessage = (color, bangla, english) => {
  // Notification for english language for
  if (netFeeLang === "bn") {
    if (color === "success") {
      return toast.success(bangla);
    } else {
      return toast.error(bangla);
    }
  }
  // Notification for Bangla language
  if (netFeeLang === "en") {
    if (color === "success") {
      return toast.success(english);
    } else {
      return toast.error(english);
    }
  }
};
export const createOLT = async (data, setIsLoading, dispatch, setShow) => {
  setIsLoading(true);
  try {
    const res = await apiLink.post("/olt", data);

    dispatch(createIspOwnerOLTSuccess(res.data?.data));
    toast.success(res.data.message);
    setShow(false);
  } catch (error) {
    toast.error(error.response?.data?.message);
  }
  setIsLoading(false);
};

export const updateOLT = async (
  ispOwner,
  data,
  setIsLoading,
  dispatch,
  setShow,
) => {
  setIsLoading(true);
  try {
    const res = await apiLink.patch(`/olt/${ispOwner}/${data?.id}`, data);

    dispatch(updateIspOwnerOLTSuccess(res.data?.data));
    toast.success(res.data.message);
    setShow(false);
  } catch (error) {
    toast.error(error.response?.data?.message);
  }
  setIsLoading(false);
};

export const deleteOLT = async (ispOwner, id, dispatch) => {
  try {
    const res = await apiLink.delete(`/olt/${ispOwner}/${id}`);

    dispatch(deleteIspOwnerOLTSuccess(id));
    toast.success(res.data.message);
  } catch (error) {
    toast.error(error.response?.data?.message);
  }
};

export const getOLT = async (ispOwner, setIsLoading, dispatch) => {
  setIsLoading(true);
  try {
    const res = await apiLink.get(`/olt/${ispOwner}`);

    dispatch(getIspOwnerOLTSuccess(res.data?.data));
  } catch (error) {
    toast.error(error.response?.data?.message);
  }
  setIsLoading(false);
};

export const getOltEnableVendors = async (dispatch, setIsLoading) => {
  setIsLoading(true);
  try {
    const res = await apiLink.get(`olt/enable/vendors`);

    dispatch(getOltEnableVendorsSuccess(res.data?.data));
  } catch (error) {
    toast.error(error.response?.data?.message);
  }
  setIsLoading(false);
};

export const getActiveCustomerONUInformation = async (
  dispatch,
  ispOwner,
  mikrotik,
  macAddress,
  setIsLoading,
  olt = null,
) => {
  setIsLoading(true);
  try {
    const res = await apiLink.get(
      `/olt/${ispOwner}/${mikrotik}/onu-information?olt=${olt}&macAddress=${macAddress}`,
    );

    dispatch(getCustomerONUSuccess(res.data?.data));
  } catch (error) {
    toast.error(error.message);
    dispatch(getCustomerONUSuccess({}));
  }
  setIsLoading(false);
};

export const syncOlSyncOltUsers = async (ispOwner, setIsLoading, oltId) => {
  setIsLoading(true);
  try {
    const url = oltId
      ? `/olt/sync/${ispOwner}?olt=${oltId}`
      : `/olt/sync/${ispOwner}`;

    const res = await apiLink.get(url);

    toast.success(res.data.message);
  } catch (error) {
    toast.error(error.message);
  }
  setIsLoading(false);
};

export const getOltUsers = async (ispOwner, setIsLoading, dispatch) => {
  setIsLoading(true);
  try {
    const res = await apiLink.get(`/olt/users/${ispOwner}`);

    dispatch(getOLTUsersSuccess(res.data?.data));
  } catch (error) {
    toast.error(error.response?.data?.message);
  }
  setIsLoading(false);
};

export const getOnuLaserInformation = async (
  dispatch,
  userId,
  setIsLoading,
) => {
  setIsLoading(true);
  try {
    const res = await apiLink.get(`olt/users/laser/${userId}`);

    dispatch(updateOLTUsersSuccess(res.data?.data));
    toast.success(res.data.message);
  } catch (error) {
    toast.error(error.message);
  }
  setIsLoading(false);
};

export const oltAndCustomerDelete = async (dispatch, userId) => {
  try {
    const res = await apiLink.delete(`/olt/users/laser/${userId}`);
    dispatch(deleteOLTCustomerSuccess(userId));
    // langMessage(
    //   "success",
    //   "ওএলটি এন্ড কাস্টোমার ডিলিট সফল হয়েছে",
    //   "OLT And Customer delete successful",
    // );
    toast.success(res?.data?.message);
  } catch (error) {
    toast.error(error?.message);
  }
};

export const createNetworkPoint = async (
  dispatch,
  data,
  setIsLoading,
  setShow,
  resetForm,
) => {
  setIsLoading(true);
  try {
    const res = await apiLink.post("/network", data);

    dispatch(postNetworkPointSuccess(res.data?.data));

    toast.success(res.data.message);

    setShow(false);
    resetForm();
  } catch (error) {
    toast.error(error.response?.data?.message);
  }
  setIsLoading(false);
};

export const getNetworkPoint = async (dispatch, setIsLoading) => {
  setIsLoading(true);
  try {
    const res = await apiLink.get(`/network`);

    dispatch(getNetworkPointSuccess(res.data?.data));
  } catch (error) {
    toast.error(error.response?.data?.message);
  }
  setIsLoading(false);
};

export const deleteNetworkPoint = async (dispatch, deviceId) => {
  try {
    await apiLink.delete(`/network/${deviceId}`);
    dispatch(deleteNetworkPointSuccess(deviceId));
    langMessage(
      "success",
      "নেটওয়ার্ক ডিলিট সফল হয়েছে",
      "Network  delete successful",
    );
  } catch (error) {
    toast.error(error.response?.data?.message);
  }
};

export const assignNetworkDecice = async (
  dispatch,
  data,
  setIsLoading,
  setShow,
) => {
  setIsLoading(true);
  try {
    const res = await apiLink.post("/network/diagram/device", data);

    dispatch(getNetworkDiagramSuccess(res.data?.data));
    toast.success(res.data.message);
    setShow(false);
  } catch (error) {
    toast.error(error.message);
  }
  setIsLoading(false);
};

export const reassignNetworkDiagramDevice = async (
  dispatch,
  data,
  setIsLoading,
  setShow,
) => {
  setIsLoading(true);
  try {
    const res = await apiLink.patch(`/network/diagram/device`, data);

    dispatch(getNetworkDiagramSuccess(res.data?.data));
    toast.success(res.data.message);
    setShow(false);
  } catch (error) {
    toast.error(error.message);
  }
  setIsLoading(false);
};

export const deleteDeviceFromNetworkDiagram = async (
  dispatch,
  network,
  parent,
  setIsLoading,
) => {
  setIsLoading(true);
  try {
    const res = await apiLink.delete(
      `/network/diagram/device/${network}/${parent}`,
    );

    dispatch(getNetworkDiagramSuccess(res.data?.data));
    toast.success(res.data.message);
  } catch (error) {
    toast.error(error.response?.data?.message);
  }
  setIsLoading(false);
};

export const updateNetworkDeviceOutput = async (
  dispatch,
  output,
  data,
  setIsLoading,
  setShow,
) => {
  setIsLoading(true);
  try {
    const res = await apiLink.patch(`/network/device/${output}`, data);

    dispatch(updateNetworkDeviceOutputSuccess(res.data?.data));
    toast.success(res.data.message);
    setShow(false);
  } catch (error) {
    toast.error(error.message);
  }
  setIsLoading(false);
};

export const getNetworkDiagram = async (dispatch, point, setIsLoading) => {
  setIsLoading(true);
  try {
    dispatch(getNetworkDiagramSuccess({}));

    const res = await apiLink.get(`network/diagram/${point}`);
    dispatch(getNetworkDiagramSuccess(res.data?.data));
  } catch (error) {
    toast.error(error.response?.data?.message);
  }
  setIsLoading(false);
};
